import { useEffect } from "react";
import { useGetSupplierProductsBySupplierId } from "../../../hooks/supplierproducts/useGetSupplierProductsBySupplierId";
import { SelectField, } from "melco-shared-logic";

export type HoopSupplierProductSelectProps = {
  supplier_id: string;
  value: string;
  onChange: (value: string) => void;
  data: any;
};

export const HoopSupplierProductSelect: React.FC<
  HoopSupplierProductSelectProps
> = ({
  supplier_id,
  value,
  onChange,
  // data
}) => {

    let { data } = useGetSupplierProductsBySupplierId(supplier_id ?? "");
    useEffect(() => { }, []);

    let options = [];
    options = data?.map((s) => {
      return {
        label: s.name,
        value: s.id,
      };
    });
    console.log(supplier_id);
    console.log(data);
    console.log(options);
    return (
      <>
        {
          <SelectField
            name="supplier_product_id"
            options={options}
            onChange={(v: string) => {
              onChange(v);
            }}
            allowClear
            value={value}
            style={{ width: "100%", minWidth: "150px" }}
          />
        }
      </>
    );
  };
